<template>
  <grid-container-fi
    v-if="requestHandlingFeeBanner"
    class="handling-fee-limit-banner-fi"
    :class="{ 'handling-fee-limit-banner-fi--visible': isVisible }"
    grid-class="fi-h-full"
    :container="false"
  >
    <div class="handling-fee-limit-banner-fi__content fi-col-span-12">
      <span class="handling-fee-limit-banner-fi__text">
        {{ $dict.get('handling-Fee-Banner.Banner', [handlingFeeLimit || '']) }}
      </span>
      <icon-fi
        class="handling-fee-limit-banner-fi__close"
        icon="close"
        @click="close"
      />
    </div>
  </grid-container-fi>
</template>

<script setup lang="ts">
import { IconFi } from 'atoms';
import { computed } from 'vue';

import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';
import { useHandlingFeeCookie } from '@/components/handling-fee-limit-banner-fi/handlingFeeCookie';
import { useNavigationStore } from '@/store/pinia/navigation';

defineOptions({
  name: 'HandlingFeeLimitBannerFi',
});

const props = defineProps<{
  handlingFeeLimit: string | null;
}>();

const navigationStore = useNavigationStore();
const { disableHandlingFeeLimitBanner } = useHandlingFeeCookie();

const requestHandlingFeeBanner = computed(
  () =>
    navigationStore.requestHandlingFeeBanner &&
    props.handlingFeeLimit !== null &&
    !navigationStore.isAssistedServiceSalesforce,
);

/**
 * The one place the banner's height offset is decided: every .header-height element in the page
 * picks it up from this class through a `:has()` rule, so no other rendering has to know about the
 * banner.
 *
 * The `v-if` above does not test `enableHandlingFeeBanner`, so this class is what collapses the
 * banner when the close button switches it off - and what keeps it collapsed while it is scrolled
 * out, client-only state that starts false on both sides of hydration.
 */
const isVisible = computed(() => navigationStore.showHandlingFeeBanner);

const close = () => {
  disableHandlingFeeLimitBanner();
  navigationStore.setEnableHandlingFeeBanner(false);
};
</script>

<style scoped src="./handling-fee-limit-banner-fi" />
